export const getKValue = data => {
  if (data < 1000) return data;
  return `${Math.round(data / 100) / 10} K`;
};
